import SnapshotManagement from './SnapshotManagement';

export default SnapshotManagement;
